module.exports = __webpack_public_path__ + "barcode-reader.svg?4eae5215e1ef2d6a546c98fbca57cd44";